module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('only-container', [_c('only-loading', {
    attrs: {
      "loading": _vm.loading
    }
  }, [(!_vm.notExisted && _vm.post) ? _c('only-article', {
    staticClass: "animated",
    class: _vm.themeCfg.animated && _vm.themeCfg.animated.post,
    attrs: {
      "article": _vm.post,
      "config": _vm.config
    }
  }) : _c('h1', [_vm._v("This Post is Not Existed")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e130c880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Post.vue
// module id = 178
// module chunks = 1